/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import { bool, string, shape } from "prop-types";
import { Col, Row } from "react-bootstrap";
import { isEmpty } from "lodash";
import * as Yup from "yup";
import { compose } from "redux";
import { useSelector, connect } from "react-redux";
import { withFormik, Form, Field } from "formik";
import cx from "classnames";

import { actions as formActions, selectors as formSelectors } from "reducers/form";

import { actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";

import { selectors as sessionSelectors } from "reducers/session";

import * as i18nUtils from "util/i18n";

import { useTransaction } from "hooks/useTransactions";

import Button from "pages/_components/Button";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";

import CustomData from "pages/_components/CustomData/CustomData";
import Credential from "pages/_components/fields/credentials/Credential";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedAmount from "pages/_components/FormattedAmount";
import InfoTag from "pages/echeck/components/InfoTag";
import { transactionStatus } from "pages/transactions/constants";
import I18n from "pages/_components/I18n";
import { TransactionCard, TransactionHeader, TransactionSign } from "pages/_components/TransactionCard";

const NewPaymentTransactionPage = ({ isDesktop, isCancellingTransaction, fetchingCancel, activeEnvironment }) => {
    const formatTransactionPayment = (data, idTransaction) => {
        const formData = {
            ...data,
            idTransaction,
            totalAmount: data.amount.quantity,
        };

        return { ...formData };
    };

    const { isLoading, transaction, dispatch, handleSignTransaction, push, id, status } = useTransaction(
        `/newServicePayment/confirm`,
        afipPaymentLinkActions.setServicesPaymentData,
        null, // no hay nada que limpiar
        formatTransactionPayment,
    );

    const { user } = useSelector((_state) => _state.session);

    const { isBackoffice } = status;
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const [transactionData, setTransactionData] = useState(null);

    useEffect(() => {
        if (transaction && transaction?.data && transaction?.data?.params) {
            const { params, companyName, sequenceNumber, serviceAdded } = transaction?.data;

            const {
                paymentCode,
                categoryName,
                entityName,
                conceptName,
                alias,
                referenceText,
                reference,
                accountLabel,
                addServicesChecked,
                accountType,
                currency,
                paymentFromAdheredService,
                adheredAlias,
            } = params;

            setTransactionData({
                paymentCode,
                categoryName,
                entityName,
                conceptName,
                alias,
                serviceAdded,
                referenceText,
                reference,
                accountLabel,
                addServicesChecked,
                accountType,
                currency,
                companyName,
                sequenceNumber,
                paymentFromAdheredService,
                adheredAlias,
            })
        }
    }, [transaction])


    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "new.service.payment.link.title",
        id,
        "servicePaymentTransactionPage",
    );

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    const showSignButton =
        isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId)) &&
        transaction.idTransactionStatus === transactionStatus.PENDING;

    const tagType =
        // eslint-disable-next-line no-nested-ternary
        transaction.idTransactionStatus === transactionStatus.FINISHED
            ? "tag-success"
            : transaction.idTransactionStatus === transactionStatus.FAILED ||
                transaction.idTransactionStatus === transactionStatus.CANCELLED
                ? "tag-error"
                : "tag-warning";

    const toggleShowMore = () => {
        setShowMoreData((prev) => !prev);
    };

    const initials =
        (transactionData?.companyName && transactionData?.companyName.match(/[A-Z]/g)?.join(""));

    const companyNameInitials = initials && initials.substring(0, 2);

    const avatar = () => (
        <div className={cx("avatar", { "avatar-big": false })}>
            <span className="service-payment-avatar-text-color" aria-hidden>
                {companyNameInitials}
            </span>
        </div>
    );

    const showAlias = () => (transactionData?.addServicesChecked && transactionData?.alias) || transactionData?.adheredAlias;

    const getAmount = (tx) => {
        const amount = tx?.data?.amount;
        if (typeof amount == 'number') return amount;
        if (typeof amount?.quantity == 'number') return amount.quantity;
        if (typeof tx?.data?.totalAmount == 'number') return tx.data.totalAmount;
        return 0;
    }

    return (
        <>
            <Notification scopeToShow="servicePaymentTransactionPage" />
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    id={!transactionData?.paymentFromAdheredService ? "new.service.payment.link.title" : "pay.added.service.link.title"}
                    metaTitle={!transactionData?.paymentFromAdheredService ? "Nuevo Pago de Servicios" : "Pagar Servicio Adherido"}
                />
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>

                            <TransactionHeader
                                title={!transactionData?.paymentFromAdheredService ? "new.service.payment.link.title" : "pay.added.service.link.title"}
                            />
                            <div className="py-6" />

                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <div className="ticket__body ticket__full-width">
                                        <div className="ticket-header-info">
                                            <div className="afip-ticket-info">
                                                {transactionData?.companyName && (
                                                    <div className="service-payment-ticket-companyName">
                                                        {companyNameInitials && avatar()}
                                                        <CustomData
                                                            titleText="services.payment.link.entity.selector.label"
                                                            titleTextType="I18N"
                                                            valueText={transactionData?.companyName || "-"}
                                                            valueTextType="TEXT"
                                                        />
                                                    </div>
                                                )}
                                                {transactionData?.companyName && (
                                                    <>
                                                        {isDesktop ? (
                                                            <>
                                                                <div className="px-10" />
                                                            </>
                                                        ) : (
                                                            <div className="py-6" />
                                                        )}
                                                    </>
                                                )}

                                                <CustomData
                                                    dataClass={`amount tag tag-echeq-character" ${tagType}`}
                                                    titleText={i18nUtils.get(
                                                        "services.payment.link.amount.ticket.label",
                                                        "Monto",
                                                    )}
                                                    valueText={
                                                        <FormattedAmount
                                                            currency="ARS"
                                                            quantity={
                                                               getAmount(transaction)
                                                            }
                                                        />
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="py-4" />
                                    </div>

                                    <div className="ticket__body ticket__full-width">
                                        <div className="ticket__divider inside-ticket__body">
                                            <div className="ticket__notch ticket__notch--left"> </div>
                                            <div className="ticket__notch ticket__notch--right"> </div>
                                        </div>
                                        {!isLoading && (
                                            <Button
                                                aria-expanded={showMoreData ? "true" : "false"}
                                                className="more-button"
                                                label={
                                                    showMoreData ? "transfers.showLess" : "transfers.showMore"
                                                }
                                                bsStyle="link"
                                                onClick={toggleShowMore}
                                                image={
                                                    showMoreData
                                                        ? "figma/icon/arrow-up.svg"
                                                        : "figma/icon/arrow-down.svg"
                                                }
                                            />
                                        )}
                                    </div>
                                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"} ticket__body ticket__full-width`}>
                                        <div>
                                            <div className="py-6" />
                                            <GridTable>
                                                <GridTable.Container columnsTemplate="fixed" columns={2}>
                                                    <GridTable.Data rowStart={1} columnStart={1}>
                                                        <CustomData
                                                            titleText={i18nUtils.get(
                                                                "services.payment.link.account.label",
                                                                "Cuenta débito",
                                                            )}
                                                            titleClass="text-Primary-primary-color"
                                                            valueText={`${transactionData?.accountLabel} ${transactionData?.accountType
                                                                } ${i18nUtils.get(`currency.label.${transactionData?.currency}`, "")}` || "-"}
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data
                                                        rowStart={isDesktop ? 1 : 2}
                                                        columnStart={isDesktop ? 2 : 1}
                                                        className="pxl-2">
                                                        <CustomData
                                                            titleText={i18nUtils.get(
                                                                "new.service.payment.link.concept.label",
                                                                "Concepto",
                                                            )}
                                                            valueText={transactionData?.conceptName || "-"}
                                                            valueClass="concept-text"
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data
                                                        rowStart={isDesktop ? 2 : 3}
                                                        columnStart={1}>
                                                        <CustomData
                                                            titleText={i18nUtils.get(
                                                                "services.payment.link.category.selector.label",
                                                                "Rubro",
                                                            )}
                                                            titleClass="text-Primary-primary-color"
                                                            valueText={transactionData?.categoryName || "-"}
                                                        />
                                                    </GridTable.Data>
                                                    <GridTable.Data
                                                        rowStart={isDesktop ? 2 : 4}
                                                        columnStart={isDesktop ? 2 : 1}
                                                        className="pxl-2">
                                                        <div className="company-info-container">
                                                            <CustomData
                                                                titleText={i18nUtils.get(
                                                                    "services.payment.link.entity.selector.label",
                                                                    "Empresa",
                                                                )}
                                                                valueText={transactionData?.entityName || "-"}
                                                            />
                                                            {transactionData?.addServicesChecked && transactionData?.serviceAdded && (
                                                                <div className="added-info-tag">
                                                                    <InfoTag
                                                                        type="info"
                                                                        message={i18nUtils.get(
                                                                            "service.payment.cuit.adhered",
                                                                            "Agendado",
                                                                        )}
                                                                        tagBackground="success"
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </GridTable.Data>
                                                    <GridTable.Data
                                                        rowStart={isDesktop ? 3 : 5}
                                                        columnStart={1}>
                                                        <CustomData
                                                            titleText={i18nUtils.get(
                                                                "services.payment.link.paymentCode.label",
                                                                "Código de pago",
                                                            )}
                                                            titleClass="text-Primary-primary-color"
                                                            valueText={transactionData?.paymentCode || "-"}
                                                        />
                                                    </GridTable.Data>
                                                    {transaction.idTransactionStatus === transactionStatus.FINISHED &&
                                                        <div className="pxl-2">
                                                            <CustomData
                                                                titleText={i18nUtils.get(
                                                                    "vep.paymentId",
                                                                    "ID de pago",
                                                                )}
                                                                titleClass="text-Primary-primary-color"
                                                                valueText={transactionData?.sequenceNumber || "-"}

                                                            />
                                                        </div>

                                                    }
                                                    {showAlias() &&
                                                        <div className={transaction.idTransactionStatus !== transactionStatus.FINISHED ? "pxl-2" : ""}>
                                                            <CustomData
                                                                titleText={i18nUtils.get(
                                                                    "adheredServices.link.alias",
                                                                    "Alias",
                                                                )}
                                                                valueText={transactionData?.alias || transactionData?.adheredAlias || "-"}
                                                            />
                                                        </div>

                                                    }
                                                    {transactionData?.reference &&
                                                        <div className={
                                                            (transaction.idTransactionStatus === transactionStatus.FINISHED && showAlias()) ||
                                                                (transaction.idTransactionStatus !== transactionStatus.FINISHED && !showAlias()) ? "pxl-2" : ""}>
                                                            <CustomData
                                                                titleText={transactionData?.referenceText || "Referencia"}
                                                                titleClass="text-Primary-primary-color"
                                                                valueText={transactionData?.reference || "-"}
                                                            />
                                                        </div>
                                                    }
                                                </GridTable.Container>
                                            </GridTable>
                                        </div>
                                        <div className="py-6" />
                                        <TransactionSign
                                            hasVaucher
                                            isDesktop={isDesktop}
                                            noDate
                                            isSmall
                                            creationTime
                                            showMoreData={showMoreData}
                                        />
                                    </div>

                                    <div
                                        className="ticket__footer"
                                        data-copytext={i18nUtils.get("global.ticketCopyText")}
                                    />
                                </div>
                            </div>

                        </TransactionCard>
                    </div>
                </div>
                {!isBackoffice && (
                    <Row className="form-actions">
                        <>
                            <Col
                                xs={12}
                                md={4}
                                mdOffset={showSignButton || transaction.idTransactionStatus === transactionStatus.FINISHED ||
                                    transaction.idTransactionStatus === transactionStatus.FAILED ||
                                    transaction.idTransactionStatus === transactionStatus.CANCELLED ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className="btn btn-outline"
                                />
                                {/* {transaction.idTransactionStatus === transactionStatus.PENDING && (
                                    <Button
                                        className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                        label="forms.cancelTransaction.link"
                                        onClick={() => dispatch(formActions.changeCancelTransaction(true))}
                                    />
                                )} */}
                            </Col>

                            <Col xs={12} md={4}>
                                {(transaction.idTransactionStatus === transactionStatus.FINISHED ||
                                    transaction.idTransactionStatus === transactionStatus.FAILED ||
                                    transaction.idTransactionStatus === transactionStatus.CANCELLED) && (
                                        <Button
                                            className="btn btn-primary"
                                            image="images/figma/icon/download.svg"
                                            label="global.download"
                                            onClick={handleDownload}
                                        />
                                    )}

                                {showSignButton && (
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                )}
                            </Col>
                            {transaction.idTransactionStatus === transactionStatus.FINISHED && !isDesktop && (
                                <Col xs={12} md={4}>
                                    <Button
                                        className="btn btn-outline"
                                        image="images/figma/icon/share.svg"
                                        label="global.share"
                                        onClick={() => {
                                            handleShareMobile();
                                        }}
                                    />
                                </Col>
                            )}
                        </>
                        {/* {!isCancellingTransaction ? (
                            <>
                                <Col
                                    xs={12}
                                    md={4}
                                    mdOffset={transaction.idTransactionStatus !== transactionStatus.PROCESSING ? 2 : 4}>
                                    {transaction.idTransactionStatus !== transactionStatus.PENDING && (
                                        <Button
                                            onClick={() => dispatch(push("/desktop"))}
                                            label="forms.transaction.ticket.actions.backToHome"
                                            className={`btn${
                                                transaction.idTransactionStatus === transactionStatus.FAILED ||
                                                transaction.idTransactionStatus === transactionStatus.FINISHED ||
                                                transaction.idTransactionStatus === transactionStatus.CANCELLED
                                                    ? " btn-outline"
                                                    : " btn-primary"
                                            }`}
                                        />
                                    )}
                                    {transaction.idTransactionStatus === transactionStatus.PENDING && (
                                        <Button
                                            className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                            label="forms.cancelTransaction.link"
                                            onClick={() => dispatch(formActions.changeCancelTransaction(true))}
                                        />
                                    )}
                                </Col>

                                <Col xs={12} md={4}>
                                    {(transaction.idTransactionStatus === transactionStatus.FINISHED ||
                                        transaction.idTransactionStatus === transactionStatus.FAILED ||
                                        transaction.idTransactionStatus === transactionStatus.CANCELLED) && (
                                        <Button
                                            className="btn btn-primary"
                                            image="images/figma/icon/download.svg"
                                            label="global.download"
                                            onClick={handleDownload}
                                        />
                                    )}

                                    {showSignButton && (
                                        <Button
                                            onClick={handleSignTransaction}
                                            label="forms.signTransaction.link"
                                            className="btn btn-primary"
                                        />
                                    )}
                                </Col>
                                {transaction.idTransactionStatus === transactionStatus.FINISHED && !isDesktop && (
                                    <Col xs={12} md={4}>
                                        <Button
                                            className="btn btn-outline"
                                            image="images/figma/icon/share.svg"
                                            label="global.share"
                                            onClick={() => {
                                                handleShareMobile();
                                            }}
                                        />
                                    </Col>
                                )}
                            </>
                        ) : (
                            <Form className="above-the-fold container--layout">
                                <Row>
                                    <Col xs={12} md={4} mdOffset={2}>
                                        <Field
                                            idForm="form.credential"
                                            name="password"
                                            labelText="form.credential.password.label"
                                            placeholderText="Ej: Ju@n_123"
                                            component={Credential}
                                            type="password"
                                        />
                                    </Col>
                                    <Col xs={12} md={4} className="align-items-end">
                                        <div className="form-group hidden-label">
                                            <div className="button-group">
                                                <Button
                                                    block
                                                    type="submit"
                                                    label="global.send"
                                                    bsStyle="primary"
                                                    loading={fetchingCancel}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )} */}
                    </Row>
                )}
            </MainContainer>
        </>
    );
};

NewPaymentTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
    isCancellingTransaction: bool.isRequired,
    fetchingCancel: bool.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    transaction: shape({}).isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    idTransaction: string.isRequired,
    activeEnvironment: shape({}).isRequired,
};

const mapStateToProps = (state) => ({
    isCancellingTransaction: formSelectors.getIsCancellingTransaction(state),
    fetchingCancel: formSelectors.getFetching(state),
    transaction: formSelectors.getTransaction(state),
    idTransaction: formSelectors.getTransaction(state).idTransaction,
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default compose(
    connect(mapStateToProps),
    // withFormik({
    //     validateOnChange: false,
    //     validateOnBlur: false,
    //     mapPropsToValues: (props) => ({
    //         id: props.match.params.id,
    //         transaction: props.transaction,
    //         isCancellingTransaction: props.isCancellingTransaction,
    //         password: "",
    //     }),
    //     validationSchema: (props) =>
    //         Yup.object().shape({
    //             password: props.isCancellingTransaction
    //                 ? Yup.string().required(i18nUtils.get("deposits.request.required"))
    //                 : Yup.string().notRequired(),
    //         }),
    //     handleSubmit: ({ password }, formikBag) => {
    //         const { dispatch, isCancellingTransaction } = formikBag.props;
    //         if (isCancellingTransaction) {
    //             dispatch(formActions.cancelTransaction({ credentials: { password, otp: "" }, formikBag }));
    //         }
    //     },
    // }),
)(NewPaymentTransactionPage);
